module.exports = __webpack_public_path__ + "img/251-samoa.4ca34940.svg";